import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AdminSetting } from '../models/admin.models';
import { ApiResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminSettingsService {
  private baseUrl = `${environment.apiBaseUrl}/admin/settings`;

  constructor(private http: HttpClient) {}

  getSettings(): Observable<Record<string, string>> {
    return this.http.get<ApiResponse<Record<string, string>>>(this.baseUrl).pipe(
      map(res => res.data)
    );
  }

  updateSettings(data: { settings: { key: string, value: string }[] }): Observable<Record<string, string>> {
    return this.http.put<ApiResponse<Record<string, string>>>(this.baseUrl, data).pipe(
      map(res => res.data)
    );
  }
}
